import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cc8da37"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\project\\bigBee\\bigbee_backend_ui_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc8da37')) {
      api.createRecord('2cc8da37', component.options)
    } else {
      api.reload('2cc8da37', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cc8da37", function () {
      api.rerender('2cc8da37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UpdatePassword/index.vue"
export default component.exports